import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Circle = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <circle
        cx='12'
        cy='12'
        r='9.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
    ) : (
      <path
        d='M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
